import { cn } from "@/lib/utils";
import {
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
} from "./ui/pagination";
const GeneratePaginationLinks = (
  currentPage: number,
  totalPages: number,
  onPageChange: (page: number) => void
) => {
  const pages: JSX.Element[] = [];
  if (totalPages <= 6) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <PaginationItem key={i}>
          <PaginationLink
            className={cn(
              "h-6 w-6 cursor-pointer",
              i === currentPage
                ? "border-primary-2 rounded-[6px]"
                : "border-none"
            )}
            onClick={() => onPageChange(i)}
            isActive={i === currentPage}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
  } else {
    for (let i = 1; i <= 2; i++) {
      pages.push(
        <PaginationItem key={i}>
          <PaginationLink
            className={cn(
              "h-6 w-6 cursor-pointer",
              i === currentPage
                ? "border-primary-2 rounded-[6px]"
                : "border-none"
            )}
            onClick={() => onPageChange(i)}
            isActive={i === currentPage}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
    if (2 < currentPage && currentPage < totalPages - 1) {
      pages.push(<PaginationEllipsis key={currentPage + 'ellipsis1'} />);
      pages.push(
        <PaginationItem key={currentPage}>
          <PaginationLink
            className={cn(
              "h-6 w-6 cursor-pointer",
              currentPage ? "border-primary-2 rounded-[6px]" : "border-none"
            )}
            onClick={() => onPageChange(currentPage)}
            isActive={true}
          >
            {currentPage}
          </PaginationLink>
        </PaginationItem>
      );
    }
    pages.push(<PaginationEllipsis key={currentPage + 'ellipsis2'} />);
    for (let i = totalPages - 1; i <= totalPages; i++) {
      pages.push(
        <PaginationItem key={i}>
          <PaginationLink
            className={cn(
              "h-6 w-6 cursor-pointer",
              i === currentPage
                ? "border-primary-2 rounded-[6px]"
                : "border-none"
            )}
            onClick={() => onPageChange(i)}
            isActive={i === currentPage}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
  }
  return pages;
};

export default GeneratePaginationLinks;
